import R from "lodash/isFunction";
import z from "lodash/get";
import d from "./sort-controls.vue.js";
import c from "./cell-types/pendo-checkbox-cell.vue.js";
import u from "./cell-types/tree.vue.js";
import I from "../icon/pendo-icon.vue.js";
import f from "./filter-panel.vue.js";
import { PendoTooltip as m } from "../../directives/tooltip/pendo-tooltip.js";
import { findNodeByContent as L, elementHasOverflow as M } from "../../utils/dom.js";
m.options.disposeTimeout = 0;
const Q = {
  name: "TableHeaderCell",
  inject: ["$table"],
  components: {
    SortControls: d,
    Checkbox: c,
    Tree: u,
    FilterPanel: f,
    PendoIcon: I
  },
  directives: {
    PendoTooltip: m
  },
  props: {
    column: {
      type: Object
    },
    columnIndex: {
      type: Number
    }
  },
  data() {
    return {
      tooltipContent: null
    };
  },
  computed: {
    fixedColumnStyle() {
      if (this.$table.overflowX) {
        if (this.column.fixed === "left")
          return {
            left: `${this.column.fixedPos}px`
          };
        if (this.column.fixed === "right")
          return {
            right: `${this.column.fixedPos}px`
          };
      }
    },
    headerCellClassName() {
      return this.$table.headerCellClassName ? R(this.$table.headerCellClassName) ? this.$table.headerCellClassName({
        row: {},
        column: this.column
      }) : this.$table.headerCellClassName : "";
    },
    isFiltered() {
      return this.column.filters ? this.column.filters.some((e) => e.checked) : !1;
    },
    isFixedRight() {
      return this.column.fixed === "right" && this.$table.overflowX && this.$table.scrollRightToLeft;
    },
    isFixedLeft() {
      return this.column.fixed === "left" && this.$table.overflowX && this.$table.scrollLeftToRight;
    },
    isSorted() {
      const e = z(this.$table.sortStore, "column.property") === this.column.property, t = ["ascending", "descending"].includes(this.$table.sortStore.activeSort);
      return e && t;
    },
    isHover() {
      return this.columnIndex === this.$table.hoverColumnHeader || this.$table.filterStore.column === this.column && this.$table.filterStore.visible;
    },
    showEllipsis() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === "ellipsis";
    },
    showTitle() {
      return (this.column.showOverflow || this.$table.showAllOverflow) === "title";
    },
    showTooltip() {
      return ["actions", "index", "checkbox", "tree"].includes(this.column.type) ? !1 : this.column.showOverflow === !0 || this.column.showOverflow === "tooltip" || this.$table.showAllOverflow === !0 || this.$table.showAllOverflow === "tooltip";
    }
  },
  methods: {
    handleCellMouseenter({ currentTarget: e }) {
      if (this.$table.toggleColumnHeaderHover(this.column, this.columnIndex), !this.showTooltip) {
        this.tooltipContent = null;
        return;
      }
      const t = L(this.column.label, e);
      if (!t.length) {
        this.tooltipContent = null;
        return;
      }
      M(t[0]) ? requestAnimationFrame(() => {
        this.tooltipContent = this.column.label;
      }) : this.tooltipContent = null;
    },
    handleCellMouseleave() {
      this.$table.toggleColumnHeaderHover();
    },
    handleResizeMousedown(e) {
      this.$emit("resize", e, this.column, this.columnIndex);
    },
    onCheckboxChange(e) {
      this.$table.toggleAllRowsSelect(e);
    },
    toggleSort(e) {
      if (e.stopPropagation(), this.column.sortable)
        return this.$table.setActiveSort(this.column.property);
    }
  },
  render(e) {
    const {
      $table: t,
      column: l,
      columnIndex: n,
      isFiltered: p,
      isFixedRight: b,
      isFixedLeft: x,
      isHover: C,
      isSorted: r,
      fixedColumnStyle: w,
      handleResizeMousedown: g,
      headerCellClassName: v,
      onCheckboxChange: _,
      showTooltip: $,
      showEllipsis: S,
      tooltipContent: y
    } = this, { colSpan: k, filters: a, label: i, property: A, rowSpan: H, sortable: T, type: s } = l;
    function N() {
      let o = i;
      const h = `${s || A}Header`;
      if (t.$slots[h] && (o = t.$slots[h]({
        column: l,
        columnIndex: n
      })), s)
        switch (s) {
          case "checkbox":
            t.checkboxConfig.headerLabel ? o = t.checkboxConfig.headerLabel : t.checkboxConfig.selectAll !== !1 && (o = e(c, {
              props: {
                checked: t.isAllSelected,
                indeterminate: t.isIndeterminate
              },
              on: {
                change: _
              }
            }));
            break;
          case "tree":
            t.treeConfig.expandAll !== !1 && (o = e(u));
            break;
          case "index":
            o = i || "#";
            break;
          default:
            o = i;
            break;
        }
      return e("span", [o]);
    }
    function O() {
      const o = [];
      return T && o.push(e(d, { props: { column: l } })), a && a.length && o.push(e(f, { props: { column: l } })), o.length ? e(
        "div",
        {
          class: "pendo-table__column-actions"
        },
        o
      ) : null;
    }
    function F() {
      return t.resizable && l.allowResize ? e("div", {
        class: "pendo-table__resizable",
        on: {
          mousedown: g
        }
      }) : null;
    }
    return e(
      "th",
      {
        class: [
          "pendo-table__column",
          v,
          {
            "pendo-table__column--sortable": l.sortable,
            "pendo-table__column--filterable": l.filters && l.filters.length,
            "pendo-table__column--center": l.headerAlign === "center",
            "pendo-table__column--right": l.headerAlign === "right",
            "pendo-table__column--fixed-left": l.fixed === "left" && t.overflowX,
            "pendo-table__column--fixed-right": l.fixed === "right" && t.overflowX,
            "pendo-table__column--fixed-shadow": l.fixedShadow,
            "is-hover": C,
            "is-fixed-left": x,
            "is-fixed-right": b,
            "is-filtered": p,
            "is-sorted": r
          }
        ],
        attrs: {
          "aria-sort": r && t.sortStore.activeSort,
          "aria-hidden": l.type === "actions",
          "aria-rowindex": 1,
          "aria-colindex": n + 1,
          role: "columnheader",
          scope: "col",
          rowspan: H,
          colspan: k
        },
        style: w,
        on: {
          mouseenter: this.handleCellMouseenter,
          mouseleave: this.handleCellMouseleave,
          click: this.toggleSort
        }
      },
      [
        e(
          "div",
          {
            class: [
              "pendo-table__cell",
              {
                "pendo-table__cell--index": l.type === "index",
                "pendo-table__cell--tooltip": $,
                "pendo-table__cell--tree": l.type === "tree",
                "pendo-table__cell--checkbox": l.type === "checkbox",
                "pendo-table__cell--ellipsis": S
              }
            ],
            directives: [
              {
                name: "pendo-tooltip",
                value: {
                  content: y,
                  delay: { show: 300, hide: 0 },
                  arrow: !0,
                  multiline: !0,
                  html: !1,
                  boundariesElement: "body"
                }
              }
            ]
          },
          [N(), O(), F()]
        )
      ]
    );
  }
};
export {
  Q as default
};
//# sourceMappingURL=table-header-cell.js.map
